import React, {useEffect, useState} from 'react'
import {connect} from "react-redux";
import {adminHttp} from "~/Admin/services/http";
import ValidationError from "~/Components/Forms/ValidationError";
import ConfirmedButton from "~/Components/ConfirmedButton/ConfirmedButton";
import Translated from '../../AdminMultilang/Translated';

const AdminEventContactItem = ({match, event, contact, onChange, onDelete, ...props}) => {

    const defaultForm = {
        name: contact?.name || '',
        title: contact?.title || '',
        email: contact?.email || '',
        phone: contact?.phone || '',
        translations: contact?.translations || ''
    };

    const [form, setForm] = useState(defaultForm);

    const [error, setError] = useState(null);
    const [message, setMessage] = useState('');

    const handleChange = (e) => {
        const name = e.target.name;
        const value = e.target.value;

        setForm({...form, [name]: value});
    };

    const handleDelete = () => {
        adminHttp
            .delete('/events/' + event.id + '/contacts/' + contact.id)
            .then(res => {
                setError(null);
                setMessage('');

                if (onDelete) {
                    onDelete();
                }

            }).catch((error) => {
            setMessage(null);
            setError(error.response?.data);
        });
    }

    const handleSubmit = () => {
        adminHttp
            .put('/events/' + event.id + '/contacts/' + contact.id, form)
            .then(res => {
                setError(null);
                setMessage('Saved successfully!');

                if (onChange) {
                    onChange();
                }

            }).catch((error) => {
            setMessage(null);
            setError(error.response?.data);
        });
    };

    return (
        <div>
            {message && (
                <div className="alert alert-success" role="alert">
                    {message}
                </div>
            )}

            {error && (
                <div className="alert alert-danger" role="alert">
                    {error.message || "Error saving event!"}
                </div>
            )}

            <div className="form-group required">
                <label className="d-block">Contact Name</label>

                <Translated
                    translations={form.translations}
                    onChanged={(values) => setForm({...form, translations: values})}
                >
                    <input
                        onChange={handleChange}
                        value={form.name}
                        name="name"
                        className="form-control"/>
                </Translated>

                <ValidationError errors={error?.errors} name="name"/>
            </div>

            <div className="form-group required">
                <label className="d-block">Job Title</label>

                <Translated
                    translations={form.translations}
                    onChanged={(values) => setForm({...form, translations: values})}
                >
                    <input
                        onChange={handleChange}
                        value={form.title}
                        name="title"
                        className="form-control"/>
                </Translated>

                <ValidationError errors={error?.errors} name="title"/>
            </div>

            <div className="form-group required">
                <label className="d-block">Email Address</label>

                <Translated
                    translations={form.translations}
                    onChanged={(values) => setForm({...form, translations: values})}
                >
                    <input
                        onChange={handleChange}
                        value={form.email}
                        name="email"
                        className="form-control"/>
                </Translated>

                <ValidationError errors={error?.errors} name="email"/>
            </div>

            <div className="form-group">
                <label className="d-block">Phone Number</label>

                <input
                    onChange={handleChange}
                    value={form.phone}
                    name="phone"
                    className="form-control"/>

                <ValidationError errors={error?.errors} name="phone"/>
            </div>


            <button
                onClick={handleSubmit}
                className="btn btn-primary text-cta float-right btn-sm">
                Save Contact
            </button>

            <ConfirmedButton
                onClick={handleDelete}
                className="btn btn-danger text-cta float-right mr-3 btn-sm">
                Delete Contact
            </ConfirmedButton>

        </div>
    );
}

const mapStateToProps = (state) => ({
    user: state.auth?.user,
    event: state.event.current,
});

export default connect(mapStateToProps)(AdminEventContactItem);
